import React from 'react';
import Layout from '../components/layout/Layout';
import Hero from '../components/home/Hero';
import StatsSection from '../components/home/StatsSection';
import FiveEsSection from '../components/home/FiveEsSection';
import ProductsSection from '../components/home/ProductsSection';
import TestimonialsSection from '../components/home/TestimonialsSection';
import AccreditationSection from '../components/home/AccreditationSection';
import OneMileSection from '../components/home/OneMileSection';

const HomePage = () => {
  return (
    <Layout>
      <Hero />
      <StatsSection />
      <FiveEsSection />
      <ProductsSection />
      <AccreditationSection />
      <TestimonialsSection />
      <OneMileSection />
    </Layout>
  );
};

export default HomePage;
